<template>
    <div class="filter-bar d-flex flex-wrap align-items-center">
        <div class="pagination" v-show="totalPages > 1">
            <a href="#" @click.prevent="onClickPreviousPage" v-show="!isInFirstPage" class="prev-arrow"><i class="fas fa-chevron-left" aria-hidden="true"></i></a>
            <a href="#" @click.prevent="onClickPage(page.name)" v-bind:class="{ active: isPageActive(page.name) }"  v-for="page in pages" v-bind:key="page.name" v-bind:disabled="page.isDisabled">{{page.name}}</a>
            <a href="#" @click.prevent="onClickNextPage" v-show="!isInLastPage"  class="next-arrow"><i class="fas fa-chevron-right" aria-hidden="true"></i></a>
        </div>
    </div>
</template>

<script>
    //https://alligator.io/vuejs/vue-pagination-component/

    var scrollOptions = {
        offset: -200
    }

    export default {
    name: 'Pagination',
    props: {
        maxVisibleButtons: {
                type: Number,
                required: false,
                default: 3
        }
    },
    computed: {
        totalPages() {
            return Math.ceil(this.$store.state.products.TotalProducts / this.$store.state.itemsPerPage);
        },
        startPage() {
            // When on the first page
            if (this.currentPage === 1) {
                return 1;
            }
            if (this.totalPages <= this.maxVisibleButtons) {
                return 1;
            }
            // When on the last page
            if (this.currentPage === this.totalPages) {
                return this.totalPages - this.maxVisibleButtons + 1;
            }
            // When in between
                return this.$store.state.currentPage - 1;
            },
        pages() {
            const range = [];

            for (let i = this.startPage;
              i <= Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
              i+= 1 ) {
                range.push({
                    name: i,
                    isDisabled: i === this.currentPage
                });
            }

            return range;
        },
        isInFirstPage() {
            return this.currentPage === 1;
        },
        isInLastPage() {
            return this.currentPage === this.totalPages;
        },
        currentPage: {
            get() {
                return this.$store.state.currentPage;
            },
            set(value) {
                this.$store.dispatch('changeCurrentPage', value);
            }
        }
    },
    methods: {
        onClickFirstPage() {
            this.currentPage = 1;
            this.$scrollTo('#productstop', 500, scrollOptions);
        },
        onClickPreviousPage() {
            this.currentPage -= 1;
            this.$scrollTo('#productstop', 500, scrollOptions);
        },
        onClickPage(page) {
            this.currentPage = page;
            this.$scrollTo('#productstop', 500, scrollOptions);
        },
        onClickNextPage() { 
            this.currentPage += 1;
            this.$scrollTo('#productstop', 500, scrollOptions);
        },
        onClickLastPage() {
            this.currentPage = this.totalPages;
            this.$scrollTo('#productstop', 500, scrollOptions);
        },
        isPageActive(page) {
            return this.currentPage === page;
        }
    }
    }
</script>